var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.image !== undefined)?_c('span',{staticClass:"sunbed-image",domProps:{"innerHTML":_vm._s(_vm.image)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }